import { type LicenceInformation } from '../context/types';

export const UPDATE_LICENSE_INFORMATION = 'UPDATE_LICENSE_INFORMATION';

export const updateProductLicenses = (payload: LicenceInformation) => ({
	type: UPDATE_LICENSE_INFORMATION,
	payload,
});
